// extracted by mini-css-extract-plugin
export default {"root":"Popper_root__Tm9qt","arrow":"Popper_arrow__9P4Ak"};